import { ByoaGuide } from '../components/ByoaGuide';

/**
 * Staff-side reference for BYOA — the same guide customers see in their portal,
 * so support can walk a customer through connecting an agent without leaving the
 * app. The endpoint is written with a placeholder host because a staff member is
 * not on a tenant's portal host; the customer's own portal fills in the real one.
 */
export function ByoaGuideView() {
  return (
    <div>
      <h1 className="view-title">BYOA — Bring Your Own Agent</h1>
      <p className="muted" style={{ marginTop: -6, maxWidth: 780 }}>
        How a customer connects their own AI agent to thevisionqc. This is the same guide shown in
        the customer portal, for reference and support.
      </p>
      <div className="panel" style={{ marginTop: 14 }}>
        <ByoaGuide endpoint="https://<customer-portal>/api/portal/mcp" />
      </div>
    </div>
  );
}
